import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import TimeTicketEntryAndEdit from "./timecardentryandedit";

const TimeTicketEntryPage = () => {
  return (
    <NavHeightAdjust>
      <TimeTicketEntryAndEdit />
    </NavHeightAdjust>
  );
};

export default TimeTicketEntryPage;
